<script>
import axios from '@/utils/axios';

export default {
  name: 'HrmAssetAssignModal',
  inject: ['setLoading'],
  props: {
    asset: { type: Object, default: null },
    employees: { type: Array, default: () => [] },
  },
  emits: ['assigned'],
  data() {
    return {
      errors: {},
      form: {
        asset_id: null,
        employee_id: '',
        quantity: 1,
        condition_at_assignment: 'excellent',
        assigned_date: this.$currentDate ? this.$currentDate() : '',
        notes: '',
      },
      conditions: [
        { id: 'excellent', name: 'Excellent' },
        { id: 'good', name: 'Good' },
        { id: 'fair', name: 'Fair' },
        { id: 'poor', name: 'Poor' },
      ],
      isSubmitting: false,
    };
  },

  watch: {
    asset: {
      immediate: true,
      handler(val) {
        this.resetForm(val);
      },
    },
  },

  computed: {
    maxQuantity() {
      if (!this.asset) return 1;
      return (this.asset.quantity || 0) - (this.asset.assigned_quantity || 0);
    },
  },

  methods: {
    resetForm(asset) {
      this.errors = {};
      this.form = {
        asset_id: asset ? asset.id : null,
        employee_id: '',
        quantity: 1,
        condition_at_assignment: 'excellent',
        assigned_date: this.$currentDate ? this.$currentDate() : '',
        notes: '',
      };
    },

    async submit() {
      if (this.isSubmitting) return;
      this.errors = {};
      this.isSubmitting = true;
      this.setLoading(true);
      try {
        await axios.post('/hrms/assets/assign', this.form);
        this.$swalToast('Asset assigned successfully.');
        this.$closeModal('hrm_asset_assign_modal');
        this.$emit('assigned');
      } catch (error) {
        if (error.type == 'validation') {
          this.errors = error.errors;
        } else {
          this.$swalToast(error.message, 'error');
        }
      } finally {
        this.setLoading(false);
        this.isSubmitting = false;
      }
    },
  }
};
</script>

<template>
  <div class="modal fade" id="hrm_asset_assign_modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Assign Asset</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="d-flex align-items-center p-2 mb-3 rounded bg-light" v-if="asset">
            <div>
              <strong class="text-dark d-block">{{ asset.name }}</strong>
              <small class="text-muted">{{ asset.code }} &middot; Available: {{ maxQuantity }} of {{ asset.quantity }}</small>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Employee <span class="text-danger">*</span></label>
            <vue-select v-model="form.employee_id" :options="employees" label="full_name" :reduce="e => e.id"
              placeholder="Select Employee"></vue-select>
            <span class="text-danger" style="font-size:12px;" v-if="errors.employee_id">{{ errors.employee_id[0] }}</span>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Quantity <span class="text-danger">*</span></label>
              <input type="number" class="form-control" v-model.number="form.quantity" min="1" :max="maxQuantity">
              <span class="text-danger" style="font-size:12px;" v-if="errors.quantity">{{ errors.quantity[0] }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Assigned Date <span class="text-danger">*</span></label>
              <input type="date" class="form-control" v-model="form.assigned_date">
              <span class="text-danger" style="font-size:12px;" v-if="errors.assigned_date">{{ errors.assigned_date[0] }}</span>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label">Condition at Assignment <span class="text-danger">*</span></label>
            <vue-select v-model="form.condition_at_assignment" :options="conditions" label="name" :reduce="c => c.id"
              placeholder="Select Condition"></vue-select>
            <span class="text-danger" style="font-size:12px;" v-if="errors.condition_at_assignment">{{ errors.condition_at_assignment[0] }}</span>
          </div>

          <div class="mb-3">
            <label class="form-label">Notes</label>
            <textarea class="form-control" rows="3" v-model="form.notes" placeholder="Optional notes"></textarea>
          </div>

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" :disabled="!form.employee_id || !form.quantity || isSubmitting" @click="submit">
            {{ isSubmitting ? 'Assigning...' : 'Assign Asset' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>